import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-cloneable', 'addRow', 'Add row');
Labels.set('ui-table-cloneable', 'removeRow', 'Remove row');
